// 导航配置
export default [
  {
    enable: true,
    title: '产品',
    id: 'cp',
    desc:
      'e签宝提供完整的全生态电子签名服务及产品，满足成长型企业、集团型企业、公共服务行业等客户的差异化需求，助力用户系统性解决签署难题，降本增效。',
    children: [
      // {
      //   title: '公有云',
      //   id: 'gyy',
      //   enable: true,
      //   children: [
      //     {
      //       title: '认证服务',
      //       id: 'rzfw',
      //       link: '/pcgw/cp/cpjs/#content2',
      //       enable: true,
      //     },
      //     {
      //       title: '存证服务',
      //       id: 'czfw',
      //       link: '/pcgw/cp/cpjs/#content4',
      //       enable: true,
      //     },
      //     {
      //       title: '电子签名API',
      //       id: 'dzqmapi',
      //       link: '/pcgw/cp/cpjs/#content1',
      //       enable: true,
      //     },
      //     {
      //       title: 'SaaS（智能合同）',
      //       id: 'saas',
      //       link: '/gw/csym1/cszym/',
      //       enable: true,
      //     },
      //     {
      //       title: '融合产品（钉钉版）',
      //       id: 'rhcp',
      //       link: '/pcgw/cp/eqbddb/',
      //       enable: true,
      //     },
      //     {
      //       title: 'e签盾',
      //       id: 'eqd',
      //       link: '',
      //       enable: false,
      //     },
      //   ],
      // },
      // {
      //   title: '混合云',
      //   id: 'hhy',
      //   enable: true,
      //   children: [
      //     {
      //       title: '天印电子签章软件',
      //       id: 'tydzqz',
      //       link: 'https://www.esign.cn/landing/mixOs',
      //       enable: true,
      //     },
      //     {
      //       title: '铁证证据管理系统',
      //       id: 'tzzjgl',
      //       link: '/pcgw/cp/tz/',
      //       enable: true,
      //     },
      //     {
      //       title: '物理印章管理系统',
      //       id: 'wlyzglxt',
      //       link: 'https://www.esign.cn/landing/signetPrint',
      //       enable: true,
      //     },
      //   ],
      // },
      // {
      //   title: '行业云',
      //   id: 'hyy',
      //   enable: true,
      //   children: [
      //     {
      //       title: '政务电子签名',
      //       id: 'esig',
      //       link: '/gw/zwdzqm/',
      //       enable: true,
      //     },
      //     {
      //       title: '医签宝',
      //       id: 'eqb',
      //       link: '/gw/yqb/',
      //       enable: true,
      //     },
      //     {
      //       title: '统一电子印章平台',
      //       id: 'dzyz',
      //       link: '/gw/tydzyzpt/',
      //       enable: true,
      //     },
      //     {
      //       title: '电子签名场景应用平台',
      //       id: 'dzqm',
      //       link: '',
      //       enable: false,
      //     },
      //   ],
      // },
      // {
      //   title: '超阅',
      //   id: 'cy',
      //   enable: false,
      //   children: [
      //     {
      //       title: '超阅版式办公套件',
      //       id: 'cybgtj',
      //       link: '',
      //       enable: false,
      //     },
      //   ],
      // },
      // {
      //   title: '法律服务',
      //   id: 'flfw',
      //   enable: true,
      //   children: [
      //     {
      //       title: '法律服务',
      //       id: 'flfw',
      //       link: '/pcgw/cp/cpjs/#content5',
      //       enable: true,
      //     },
      //   ],
      // },
      // 新的内容
      {
        title: '公有云产品',
        id: 'gyy',
        enable: true,
        children: [
          {
            title: '签管一体化电子合同云平台',
            id: 'qsyth',
            link: '/product/platform',
            enable: true,
          },
          {
            title: '钉钉智能合同',
            id: 'ddznht',
            link: '/product/dingcoop',
            enable: true,
          },
        ],
      },
      {
        title: '本地化产品',
        id: 'bdy',
        enable: true,
        children: [
          {
            title: '企业统一印章平台',
            id: 'qytyyz',
            link: '/product/corporate',
            enable: true,
          },
          {
            title: '政务统一印章平台',
            id: 'zwtyyz',
            link: '/product/gov',
            enable: true,
          },
        ],
      },
      {
        title: '更多能力',
        id: 'gdnl',
        enable: true,
        children: [
          {
            title: '开放服务',
            id: 'kffw',
            link: '/product/apiservice',
            enable: true,
          },
          {
            title: '身份认证',
            id: 'sfrz',
            link: '/product/verifyservice',
            enable: true,
          },
          {
            title: '存证服务',
            id: 'czfw',
            link: '/pcgw/cp/cpjs/#content4',
            enable: true,
          },
          {
            title: '法律服务',
            id: 'flfw',
            link: '/pcgw/cp/cpjs/#content5',
            enable: true,
          },
        ],
      },
    ],
  },
  {
    enable: true,
    title: '方案',
    id: 'jjfa',
    desc:
      '针对不同行业特点及业务场景，e签宝为客户深度定制个性化的电子签名解决方案，以满足实际应用需求，为用户带来真正便捷、高效、安全的使用体验。',
    children: [
      {
        title: '业务场景解决方案',
        id: 'ywcj',
        enable: false,
        children: [
          {
            title: '招投标',
            id: 'ztb',
            link: '',
          },
          {
            title: '采购',
            id: 'cg',
            link: '',
          },
          {
            title: '人事',
            id: 'rs',
            link: '',
          },
        ],
      },
      {
        title: '行业解决方案',
        id: 'hy',
        enable: true,
        children: [
          {
            title: '在线教育',
            id: 'zxjy',
            link: '/pcgw/jjfa/jypx/',
            enable: true,
          },
          {
            title: '银行/证券基金/保险',
            id: 'yh/zj/bx',
            link: '/pcgw/jjfa/dzptqmjjfa/',
            enable: true,
          },
          {
            title: '建筑',
            id: 'jz',
            link: '',
            enable: false,
          },
          {
            title: '医药制造/医疗卫生',
            id: 'yyzz/ylws',
            link: '/gw/yqb/',
            enable: true,
          },
          {
            title: '保险',
            id: 'bx',
            link: '',
            enable: false,
          },
          {
            title: '融资租赁',
            id: 'rzzl',
            link: '/pcgw/jjfa/xyjjfa/rzzl/',
            enable: true,
          },
          {
            title: '不动产开发（地产）',
            id: 'bdckf',
            link: '/pcgw/jjfa/fdc/',
            enable: true,
          },
          {
            title: '汽车',
            id: 'qc',
            link: '/pcgw/jjfa/qcfw/',
            enable: true,
          },
          {
            title: '物流',
            id: 'wl',
            link: '/pcgw/jjfa/wlys/',
            enable: true,
          },
          {
            title: '物业不动产',
            id: 'wybdc',
            link: '',
            enable: false,
          },
          {
            title: '连锁经营',
            id: 'lsjy',
            link: '',
            enable: false,
          },
          {
            title: '快消行业',
            id: 'kxhy',
            link: '/pcgw/jjfa/lskx/',
            enable: true,
          },
          {
            title: '制造业',
            id: 'zzy',
            link: '/pcgw/jjfa/zzy/',
            enable: true,
          },
          {
            title: '国央企',
            id: 'gyq',
            link: '',
            enable: false,
          },
          {
            title: '人力资源服务',
            id: 'rlzy',
            link: '/pcgw/jjfa/news/rlzycj/',
            enable: true,
          },
          {
            title: '民航业',
            id: 'mhy',
            link: '',
            enable: false,
          },
          {
            title: '游戏行业',
            id: 'yxhy',
            link: '',
            enable: false,
          },
        ],
      },
      {
        title: '公共服务解决方案',
        id: 'ggfwjjfa',
        enable: true,
        children: [
          {
            title: '数字政府',
            id: 'szzf',
            link: '/pcgw/jjfa/szzf/',
            enable: true,
          },
          {
            title: '信创一体化应用综合解决方案',
            id: 'cgyth',
            link: '',
            enable: false,
          },
          {
            title: '人社',
            id: 'rsdzld',
            link: '',
            enable: false,
          },
          {
            title: '不动产行业',
            id: 'bdcjydzqm',
            link: '/pcgw/jjfa/xyjjfa/bdc/',
            enable: true,
          },
          {
            title: '高校全业务电子签名解决方案',
            id: 'gxdzqm',
            link: '',
            enable: false,
          },
          {
            title: '公积金电子签名解决方案',
            id: 'gjjdzqm',
            link: '',
            enable: false,
          },
          {
            title: '市监局全程电子化电子签名解决方案',
            id: 'sjjdzqm',
            link: '',
            enable: false,
          },
        ],
      },
      {
        title: '生态集成解决方案',
        id: 'stjcjjfa',
        enable: true,
        children: [
          {
            title: '蓝凌数字化融合方案',
            id: 'll',
            link: '/pcgw/jjfa/jcjjfa/ll/',
            enable: true,
          },
        ],
      },
      {
        title: '创新业务',
        id: 'cxyw',
        enable: true,
        children: [
          {
            title: '海外签产品解决方案',
            id: 'eSignGlobal',
            link: '/site/global',
            enable: true,
          },
        ],
      },
    ],
  },
  {
    enable: true,
    title: '案例',
    id: 'al',
    desc: '基于完整的安全合规体系，e签宝为客户提供专业可靠的全程服务保障，从免费体验、电子合同工具箱到在线客服，全面细致、快速响应。',
    children: [
      {
        title: '客户案例',
        id: 'khal',
        enable: true,
        children: [
          {
            title: '客户案例',
            id: 'khal',
            link: '/site/customer-case',

            // link: '/pcgw/kh/kh/',
            enable: true,
            ssr: true,
          },
          {
            title: '客户证言',
            id: 'khzy',
            link: '/pcgw/kh/khzy/',
            enable: true,
          },
        ],
      },
    ],
  },
  {
    enable: true,
    title: '服务',
    id: 'fw',
    desc: '基于完整的安全合规体系，e签宝为客户提供专业可靠的全程服务保障，从免费体验、电子合同工具箱到在线客服，全面细致、快速响应。',
    children: [
      {
        title: '体验',
        id: 'ty',
        enable: true,
        children: [
          {
            title: '体验中心',
            id: 'tyzx',
            link: '/cs/eqbtyzx/',
            enable: true,
          },
        ],
      },
      {
        title: '工具',
        id: 'tool',
        enable: true,
        children: [
          {
            title: '合同验签',
            id: 'htyq',
            link: '/pcgw/cp/htyz/',
            enable: true,
          },
          {
            title: '合同模板',
            id: 'htmb',
            link: '/site/contract/list',
            enable: true,
            ssr: true,
          },
        ],
      },
      {
        title: '安全合规',
        id: 'aqhg',
        enable: true,
        children: [
          {
            title: '安全合规体系',
            id: 'aqhgtx',
            link: '/pcgw/cp/aqhg/',
            enable: true,
          },
        ],
      },
      {
        title: '客户服务',
        id: 'khfw',
        enable: true,
        children: [
          {
            title: '服务中心',
            id: 'service',
            link: '/site/service',
            enable: true,
            ssr: true,
          },
          {
            title: '帮助中心',
            id: 'help',
            link: 'https://help.esign.cn/',
            enable: true,
          },
        ],
      },
    ],
  },
  {
    enable: true,
    title: '行业资讯',
    id: 'hyzx',
    desc: '这里是行业风向标，可以查看关于电子签名的最新政策、行业资讯以及法律条文等，还有e签宝的最新企业动态、活动信息、签约资讯等。',
    children: [
      {
        title: '资讯',
        id: 'zx',
        enable: true,
        children: [
          {
            title: '公司动态',
            id: 'gsdt',
            link: '/pcgw/gywm/gsxw?id=15269',
            enable: true,
          },
          {
            title: '行业动态',
            id: 'hydt',
            link: '/pcgw/gywm/gsxw?id=15270',
            enable: true,
          },
          {
            title: '政策速递',
            id: 'zctd',
            link: '/site/policy',
            enable: true,
            ssr: true,
          },
        ],
      },
      {
        title: '智库',
        id: 'zk',
        enable: true,
        children: [
          {
            title: '行业报告',
            id: 'hybg',
            link: '/pcgw/xyzk/xybg/',
            enable: true,
          },
          {
            title: '法律智库',
            id: 'flzk',
            link: '/pcgw/xyzk/flzk/',
            enable: true,
          },
          {
            title: '知识科普',
            id: 'zskp',
            link: '/pcgw/gywm/gsxw?id=15271',
            enable: true,
          },
        ],
      },
    ],
  },
  {
    enable: true,
    title: '招募合作',
    id: 'zmhz',
    desc: 'e签宝坚持双赢思维，持续寻找优秀的生态伙伴强强联合，深度融合；另外还在全国范围内招募渠道合作伙伴，共享电子签名市场红利。',
    alias: '“e”起同行  共赢未来',
    layout: 'three-column-layout',

    // adImg: 'https://www.esign.cn/upload/resources/image/2020/08/31/27753_1400x800c.jpg',
    defaultAdImg: 'zmhz-bg.png',
    children: [
      {
        title: '招募合作',
        id: 'hzhb',
        enable: true,
        children: [
          // {
          //   title: '代理招募',
          //   id: 'dlzm',
          //   link: '/gfqd/',
          //   desc: '低门槛 | 高收益 | 共享百亿电签市场 | 共建签署信任网络',
          //   enable: true,
          // },
          {
            title: '生态合作',
            id: 'sthz',
            link: '/site/ecological',
            enable: true,
            ssr: true,
          },
          {
            title: '个人合伙人',
            id: 'grhhr',
            link: 'https://partner.esign.cn/',
            enable: true,
            ssr: true,
          },
        ],
      },
    ],
  },
  {
    enable: true,
    title: '关于我们',
    id: 'about',
    desc:
      '从2002年出发，e签宝已专注电子签名行业19年，以 “让签署更便捷，让信任更简单”为自身使命，通过持续的投入与努力，以优质的产品与服务，不断引领行业向前。',
    layout: 'three-column-layout',

    // adImg: 'https://www.esign.cn/upload/resources/image/2020/08/31/27732_1400x800c.jpg',
    defaultAdImg: 'about-bg.png',
    children: [
      {
        title: '关于我们',
        id: 'gywm',
        enable: true,
        children: [
          {
            title: '公司介绍',
            id: 'gsjs',
            link: '/pcgw/gywm/gsjs/',
            enable: true,
          },
          {
            title: '荣誉资质',
            id: 'ryzz',
            link: '/pcgw/gywm/jszz/',
            enable: true,
          },
          {
            title: '加入我们',
            id: 'jrwm',
            link: 'https://esign.zhiye.com/',
            enable: true,
          },
          {
            title: '联系我们',
            id: 'lxwm',
            link: '/pcgw/gywm/lxwm/',
            enable: true,
          },
        ],
      },
    ],
  },
  {
    enable: true,
    title: '开放平台',
    id: 'open',
    link: 'https://open.esign.cn/',
  },
]
